import React from 'react';

import sanitizeHtml from 'sanitize-html';

import { SANITIZE_CONFIG } from 'config/sanitizeHtmlConfig';

import './RichTextContent.styles.css';

type RichTextContentProps = {
  content: string;
  className?: string;
};

export const sanitizeRichTextHtml = (content: string): string => sanitizeHtml(content, SANITIZE_CONFIG);

const RichTextContent: React.FC<RichTextContentProps> = ({ content, className }) => {
  if (!content) return null;

  const sanitizedContent = sanitizeRichTextHtml(content);

  return (
    // eslint-disable-next-line react/no-danger
    <div className={`rich-text-content ${className || ''}`} dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
  );
};

export default RichTextContent;
